import { useTranslation } from 'react-i18next';

import * as St from './FreeDrawMessage.styles';

const FreeDrawMessage = () => {
  const { t } = useTranslation();

  return (
    <St.Container>
      <p>{t('FREE_DRAW.START_MESSAGE')}</p>
    </St.Container>
  );
};

export default FreeDrawMessage;
